import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

// Sosyal giriş (Google/Facebook) OAuth callback'inden dönen token'ı alır,
// oturumu başlatır ve kullanıcıyı sohbete yönlendirir.
export default function SocialSuccess() {
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    const token = new URLSearchParams(window.location.search).get("token");
    if (!token) {
      navigate("/login?socialError=token", { replace: true });
      return;
    }
    localStorage.setItem("biyz_token", token);

    (async () => {
      try {
        const res = await fetch("/api/platform/users/me", {
          headers: { Authorization: `Bearer ${token}` },
        });
        if (!res.ok) throw new Error();
        const u = await res.json();
        localStorage.setItem("biyz_user", JSON.stringify({
          id: u._id || u.id,
          fullName: u.fullName,
          username: u.username,
          email: u.email,
          role: u.role,
          avatar: u.avatar,
        }));
        navigate("/chat", { replace: true });
      } catch {
        localStorage.removeItem("biyz_token");
        setFailed(true);
        setTimeout(() => navigate("/login?socialError=profile", { replace: true }), 1500);
      }
    })();
  }, [navigate]);

  return (
    <Box sx={{ minHeight: "100vh", display: "flex", flexDirection: "column",
               alignItems: "center", justifyContent: "center", gap: 2, background: "#ffffff" }}>
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {failed ? "Giriş tamamlanamadı, yönlendiriliyorsunuz..." : "Giriş yapılıyor..."}
      </Typography>
    </Box>
  );
}
